import { render, staticRenderFns } from "./SidebarModification.vue?vue&type=template&id=2695b7bc&"
import script from "./SidebarModification.vue?vue&type=script&lang=js&"
export * from "./SidebarModification.vue?vue&type=script&lang=js&"
import style0 from "./SidebarModification.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports